import React, { useState } from 'react';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';
import FormInput from '../../../ui/FormInput';
import { CheckIcon, TruckIcon } from '@heroicons/react/24/outline';

const ConfirmReturnDeliveryModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  isLoading = false,
  entity 
}) => {
  const [deliveryComments, setDeliveryComments] = useState('');

  const handleConfirm = () => {
    onConfirm({
      deliveryComments: deliveryComments.trim()
    });
  };

  const handleClose = () => {
    setDeliveryComments('');
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Confirm Return Delivery"
      size="md"
    >
      <div className="py-4">
        <div className="flex items-center mb-4">
          <TruckIcon className="h-12 w-12 text-green-500 mr-4" />
          <div>
            <h3 className="text-lg font-medium text-gray-900">
              Return Items Received?
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              Please confirm that you have received the returned items from your customer.
            </p>
          </div>
        </div>
        
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
          <h4 className="text-sm font-medium text-blue-900 mb-2">
            What happens next:
          </h4>
          <ul className="text-sm text-blue-800 space-y-1">
            <li>• Return will be marked as delivered</li>
            <li>• You'll be able to update product conditions and pricing</li>
            <li>• Customer will be notified of successful return receipt</li>
            <li>• Return requests will be marked as completed</li>
          </ul>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Delivery Comments (Optional)
          </label>
          <FormInput
            as="textarea"
            rows={3}
            value={deliveryComments}
            onChange={(e) => setDeliveryComments(e.target.value)}
            placeholder="Add any notes about the condition of returned items..."
            maxLength={500}
          />
          <p className="text-xs text-gray-500 mt-1">
            {deliveryComments.length}/500 characters
          </p>
        </div>

        <div className="flex flex-col sm:flex-row-reverse gap-3">
          <Button
            onClick={handleConfirm}
            disabled={isLoading}
            isLoading={isLoading}
            variant="primary"
            className="flex items-center justify-center"
          >
            <CheckIcon className="h-4 w-4 mr-2" />
            Confirm Return Delivery
          </Button>
          <Button
            onClick={handleClose}
            disabled={isLoading}
            variant="secondary"
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmReturnDeliveryModal; 